module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "primary",
    attrs: {
      "pt0": ""
    }
  }, [_c('h6', {
    staticClass: "white--text"
  }, [_vm._v("Kilometraje")]), _vm._v(" "), _c('v-btn', {
    staticClass: "accent",
    attrs: {
      "absolute": "",
      "dark": "",
      "small": "",
      "fab": "",
      "button": "",
      "right": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.dialog = true
      }
    }
  }, [_vm._v("\n            +\n       ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-container', [_c('v-layout', [_c('v-flex', {
    staticStyle: {
      "overflow-x": "auto"
    },
    attrs: {
      "xs12": ""
    }
  }, [_c('table', {
    staticClass: "table"
  }, [_c('thead', [_c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', {
    staticClass: "pa-0 ma-0"
  }), _vm._v(" "), _c('th', [_vm._v("Fecha")]), _vm._v(" "), _c('th', [_vm._v("Vehículo")]), _vm._v(" "), _c('th', [_vm._v("Kilometraje Inicial")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tipo === 'admin'),
      expression: "tipo === 'admin'"
    }]
  }, [_vm._v("Kilometraje Final")]), _vm._v(" "), _c('th', [_vm._v("Total Facturas")]), _vm._v(" "), _c('th', [_vm._v("Comentario")])]), _vm._v(" "), _c('tbody', {
    staticClass: "ma-0 pa-0"
  }, _vm._l((_vm.kilometraje.results), function(kilometraje) {
    return _c('tr', [_c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "red--text text--darken-2 btn--small",
      attrs: {
        "icon": "",
        "pa-0": "",
        "ma-0": ""
      },
      on: {
        "click": function($event) {
          return _vm.eliminar(kilometraje)
        }
      }
    }, [_c('v-icon', [_vm._v("delete")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-left pa-0"
    }, [_c('v-btn', {
      staticClass: "blue--text text--darken-2 ",
      attrs: {
        "icon": ""
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(_vm._f("formatDate2")(kilometraje.fecha)))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.auto_name))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.kilometraje_inicial))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.tipo == 'admin'),
        expression: "tipo=='admin'"
      }],
      staticClass: "text-xs-center text-xs-left pa-0 ma-0"
    }, [_vm._v(_vm._s(kilometraje.kilometrage))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.total_facturas))]), _vm._v(" "), _c('td', {
      staticClass: "text-xs-center text-xs-left pa-0"
    }, [_vm._v(_vm._s(kilometraje.comentario))])])
  }), 0)])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "justify-center": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "persistent": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    attrs: {
      "primary": ""
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(" Kilometraje ")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Kilometraje Inicial:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje_inicial),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje_inicial", $$v)
      },
      expression: "akilometraje.kilometraje_inicial"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Kilometraje:"
    },
    model: {
      value: (_vm.akilometraje.kilometraje),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "kilometraje", $$v)
      },
      expression: "akilometraje.kilometraje"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Total Facturas:"
    },
    model: {
      value: (_vm.akilometraje.total_facturas),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "total_facturas", $$v)
      },
      expression: "akilometraje.total_facturas"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Comentario:"
    },
    model: {
      value: (_vm.akilometraje.comentario),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "comentario", $$v)
      },
      expression: "akilometraje.comentario"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.vehiculos,
      "itemText": "auto_name",
      "value": _vm.vehiculo,
      "label": "Vehiculo",
      "single-line": "",
      "bottom": ""
    },
    on: {
      "update:value": function($event) {
        _vm.vehiculo = $event
      }
    },
    model: {
      value: (_vm.vehiculo),
      callback: function($$v) {
        _vm.vehiculo = $$v
      },
      expression: "vehiculo"
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "persistent": "",
      "lazy": "",
      "full-width": ""
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Fecha",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.akilometraje.fecha),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "fecha", $$v)
      },
      expression: "akilometraje.fecha"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var save = ref.save;
        var cancel = ref.cancel;

        return [_c('v-card-actions', [_c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              return cancel()
            }
          }
        }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "flat": "",
            "primary": ""
          },
          nativeOn: {
            "click": function($event) {
              save(), _vm.filtrarfechainicio()
            }
          }
        }, [_vm._v("Aceptar")])], 1)]
      }
    }]),
    model: {
      value: (_vm.akilometraje.fecha),
      callback: function($$v) {
        _vm.$set(_vm.akilometraje, "fecha", $$v)
      },
      expression: "akilometraje.fecha"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.cerrar
    }
  }, [_vm._v("Cerrar")]), _vm._v(" "), _c('v-btn', {
    staticClass: "blue--text darken-1",
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.editarkilometraje
    }
  }, [_vm._v("Guardar")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-db8d51c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Kilometraje.vue
// module id = 452
// module chunks = 1